import { useReducer } from 'react';

function useRerender() {
  const [key, update] = useReducer(
    (key2) => key2 + 1,
    0
  );
  return [update, key];
}

export { useRerender };
//# sourceMappingURL=use-rerender.js.map
